import React from 'react';
import { Spinner } from 'react-bootstrap';
import { cssVar } from 'constants/theme';
import type { NumPrevHeatmapImage } from 'services/api/Meteorology';

interface Props {
  images: NumPrevHeatmapImage[];
  fetching: boolean;
  /** Data formatada da consulta atual (ex: '20/05/2026'). Opcional. */
  forecastDate?: string;
}

export default function NumericForecastHeatmapDisplay({
  images,
  fetching,
  forecastDate,
}: Props) {
  if (fetching) {
    return <div className="text-center mt-5"><Spinner /></div>;
  }
  if (images.length === 0) {
    return (
      <div className="images-not-found">
        Não foram encontradas imagens para as variáveis selecionadas
      </div>
    );
  }
  return (
    <div className="d-flex flex-column align-items-center gap-3 my-3">
      {images.map(({ modelo, image }) => (
        <figure key={modelo} className="m-0 text-center">
          <figcaption className="fw-bold mb-1">
            {modelo.toUpperCase()}
            {forecastDate ? ` - ${forecastDate}` : ''}
          </figcaption>
          <div className="d-flex justify-content-center bg-white">
            <img
              src={`data:image/png;base64,${image}`}
              alt={`Heatmap ${modelo}`}
              style={{ maxWidth: '70%', height: 'auto', backgroundColor: cssVar('bg-figure') }}
            />
          </div>
        </figure>
      ))}
    </div>
  );
}
